module.exports = __webpack_public_path__ + "img/filter.857e9709.svg";